import { type StreamerHistory } from "@prisma/client";
import { useLoaderData } from "react-router";
import { formatDateTimeFromString } from "#app/utils/date.ts";
import { getRecentStreamerHistory } from "#app/utils/streamers.server.ts";
import { type TwitchStream, getWhoIsStreamingUltimaOnline } from "#app/utils/twitch.server.ts";
import { type YouTubeStream, getYouTubeLiveStreams } from "#app/utils/youtube.server.ts";
import { type Route } from "./+types/index.ts";


export const meta = ({ loaderData }: Route.MetaArgs) => {

    const streamers = loaderData?.streamers as { data: TwitchStream[] };
    const streamerHistory = loaderData?.streamerHistory as StreamerHistory[];
    const totalStreamers = streamers.data.length + streamerHistory.length;

	var title = `${totalStreamers} UO Streamers in the last 30 days`;
	var description = `How many people stream UO right now? JaseOwns found ${totalStreamers} streamers in the last 30 days. Explore the list`;
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "streamers,twitch,youtube,uo,ultima online,learning,jaseowns,jase,jason"},
		// { property: "og:image", content: "https://jaseowns.com/images/blogs/blog-posts-root.png"},
		// { property: "og:image:alt", content: "Blog Posts in orange and white with black background"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export const loader = async ({request}: Route.LoaderArgs) => {
    const streamers = await getWhoIsStreamingUltimaOnline();
    const streamerHistoryFull = await getRecentStreamerHistory();

    const youTubeStreamersData = await getYouTubeLiveStreams(`"Ultima Online"|"UO Outlands"`);
    console.log(youTubeStreamersData)
    const streamerHistory = streamerHistoryFull.filter(
        (history) => !streamers.data.some((streamer) => streamer.user_name === history.streamerName)
    );

    streamerHistory.sort((a, b) => {
        if (a.lastStreamedAt > b.lastStreamedAt) {
            return -1;
        } else if (a.lastStreamedAt < b.lastStreamedAt) {
            return 1;
        } else {
            return 0;
        }
    })    

    return {streamers, streamerHistory, youTubeStreamers: youTubeStreamersData != null && youTubeStreamersData.items != null ? youTubeStreamersData.items : []}
}

export default function StreamersIndex() {
    const { streamers, streamerHistory, youTubeStreamers } = useLoaderData<typeof loader>();
    function showLinkWithBrand(streamer: StreamerHistory){

        if (streamer.brand ==  "YouTube") 
        {
            return <a href={`https://youtube.com/${streamer.streamerName}`}>
                <span aria-hidden="true" className="absolute inset-0" />
                <img src="/images/youtube.png" alt="YouTube" className="h-6 w-6 inline-block mr-4" />
                {streamer.streamerName}
            </a>    
        }
        
        return <a href={`https://twitch.tv/${streamer.streamerName}`}>
            <span aria-hidden="true" className="absolute inset-0" />
            <img src="/images/twitch.png" alt="Twitch" className="h-6 w-6 inline-block mr-4" />
            {streamer.streamerName}
        </a>
    }

    return (
        <main className="container mx-auto text-black dark:text-white">
            <h1 className="text-3xl p-4 m-2 text-cyan-900 dark:text-cyan-200">{streamers.data.length} Live Streamer{streamers.data.length == 1 ? " " : "s"} playing Ultima Online</h1>
            <div className="px-10">

                {youTubeStreamers.map((streamer: YouTubeStream) => {
                    return <div key={`youtube-${streamer.etag}`}>
                            <img src={`https://i.ytimg.com/vi/${streamer.id.videoId}/mqdefault_live.jpg`} alt="YouTube" />
                            {streamer.id.videoId}<br />
                            {streamer.snippet.title}<br />
                            {streamer.snippet.channelId}<br />
                            {streamer.snippet.channelTitle}<br />
                        </div>
                })}
                <div className="flex flex-col space-y-6 md:space-y-0 md:space-x-6 md:flex-row space-x-0">
                    <div className="mx-auto max-w-7xl overflow-hidden sm:px-6 lg:px-8">
                        <div className="-mx-px grid grid-cols-2 sm:mx-0 md:grid-cols-3 lg:grid-cols-4">
                        {streamers.data.map((streamer: TwitchStream) => (
                            <div key={streamer.id} className="group relative p-4 sm:p-6 hover:bg-slate-900">
                                <img
                                    alt={streamer.title}
                                    width={350}
                                    height={200}
                                    src={streamer.thumbnail_url.split("{width}").join("350").split("{height}").join("200")}
                                    className="aspect-square rounded-lg object-cover group-hover:opacity-75"
                                />
                                <div className="pb-4 pt-4 text-center">
                                    <h2 className="text-2xl font-medium pb-4">
                                        <a href={`https://twitch.tv/${streamer.user_name}`}>
                                            <span aria-hidden="true" className="absolute inset-0" />
                                            <img src="/images/twitch.png" alt="Twitch" className="h-6 w-6 inline-block mr-4" />
                                            {streamer.user_name}
                                        </a>
                                    </h2>
                                    <div className="flex flex-col items-center">
                                        <p className="text-sm">{streamer.viewer_count} viewer{streamer.viewer_count == 1 ? "" : "s"}</p>
                                        <p className="mt-4 text-base font-medium">{streamer.title}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
                
            </div>

            <h1 className="text-3xl p-4 m-2 text-cyan-900 dark:text-cyan-200">{streamerHistory.length} Streamers in the Past 30 days</h1>
            <div className="pb-8 px-10">
                <div className="flex flex-col space-y-6 md:space-y-0 md:space-x-6 md:flex-row space-x-0">
                    <div className="mx-auto max-w-7xl overflow-hidden sm:px-6 lg:px-8">
                        <div className="-mx-px grid grid-cols-2 sm:mx-0 md:grid-cols-3 lg:grid-cols-4">
                        {streamerHistory.map((streamer: StreamerHistory) => (
                            <div key={streamer.id} className="group relative p-4 sm:p-6">
                            <div className="pb-4 pt-10 text-center">
                                <h3 className="text-sm font-medium">
                                    {showLinkWithBrand(streamer)}
                                </h3>
                                <p className="mt-1 text-sm">Last: {formatDateTimeFromString(streamer.lastStreamedAt.toString())}</p>
                                <p className="mt-4 text-sm">First: {formatDateTimeFromString(streamer.createdAt.toString())}</p>
                            </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

